import DidTable from 'components/tables/did/DidTable'
import React from 'react'

const index = () => {
    return (
        <DidTable />
    )
}

export default index